module.exports = __webpack_public_path__ + "static/media/c43.3e69d538.png";